import { DEBUG } from '../global/config';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const logDebug = (...args: any[]) => DEBUG && console.debug(...args);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const logError = (...args: any[]) => DEBUG && console.error(...args);
